import { render, staticRenderFns } from "./TopicMessageDisplay.vue?vue&type=template&id=5e64c73a&scoped=true"
import script from "./TopicMessageDisplay.vue?vue&type=script&lang=js"
export * from "./TopicMessageDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e64c73a",
  null
  
)

export default component.exports